const getPlanPricingInformation = ({ products, planId }) => {
  return (
    products?.find(({ id }) => id === planId) || {
      disabled: true,
    }
  );
};

export default getPlanPricingInformation;
